import { useState, useEffect, useCallback } from 'react';
import { useGetAllEnvironmentsLimitation } from '../../../services/environments';
import { editCreateEnvironment } from '../../../../@xmcloud/core/messages/en';

const { tenantTypeValidation3, tenantTypeValidation4 } = editCreateEnvironment;

export interface TenantTypeValidationResult {
	tenantTypeError: string | undefined;
	setTenantTypeError: (error: string | undefined) => void;
	validateTenantType: (tenantType: number) => string | undefined;
	environmentLimits: {
		prodCount: number;
		prodLimit: number;
		nonProdCount: number;
		nonProdLimit: number;
	};
}

export const useTenantTypeValidation = (
	tenantType?: number,
	autoValidate = true,
): TenantTypeValidationResult => {
	const { data: envData } = useGetAllEnvironmentsLimitation(true);
	const [tenantTypeError, setTenantTypeError] = useState<string | undefined>(
		undefined,
	);

	const environmentLimits = {
		prodCount: envData?.data?.prodCount ?? 0,
		prodLimit: envData?.data?.prodLimit ?? 0,
		nonProdCount: envData?.data?.nonProdCount ?? 0,
		nonProdLimit: envData?.data?.nonProdLimit ?? 0,
	};

	const { prodCount, prodLimit, nonProdCount, nonProdLimit } =
		environmentLimits;

	const validateTenantType = useCallback(
		(type: number): string | undefined => {
			if (type === 1 && prodCount >= prodLimit) {
				return tenantTypeValidation3;
			}
			if (type === 0 && nonProdCount >= nonProdLimit) {
				return tenantTypeValidation4;
			}
			return undefined;
		},
		[prodCount, prodLimit, nonProdCount, nonProdLimit],
	);

	useEffect(() => {
		if (autoValidate && tenantType !== undefined) {
			const error = validateTenantType(tenantType);
			setTenantTypeError(error);
		}
	}, [tenantType, autoValidate, validateTenantType]);

	return {
		tenantTypeError,
		setTenantTypeError,
		validateTenantType,
		environmentLimits,
	};
};
